import Installation from './install'
import Account from './account'
module.exports = {
  Installation,
  Account
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/views/installation/index.js